// https://mui.com/x/introduction/licensing/#how-to-install-the-key
// we use Material UI Datagrid Pro for our grid component. It requires that the license key be set before first rendering any components.
// this file should be imported in the entry point of the app, before any components are rendered
import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_X_KEY);
